import { useDispatch } from "react-redux";
import BrandList from "./BrandList";
import { Button, Grid } from "@mui/material";
import { PermissionGuard } from "../../components/PermissionGuard";
import PageHeaderLayout from "../../components/Layout/PageHeaderLayout";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import AddEditBrand from "./AddEditBrand";
import { createContext, useState } from "react";
import { BrandServices } from "./BrandServices";
import Swal from "sweetalert2";

const BrandContext = createContext();
export default function Brand(){
    const menuDispatch = useDispatch();
    menuDispatch({
        type: 'menuSelect',
        payload: 'brand'
    });
    const navigate = useNavigate();
    const brandInitialData = {
        title:'',
        image:'',
        bLevel:'',
        isActive:false,
        categoryId: '',
        subCategoryId: '',
        services: [],
        serviceIds: []
    }
    const [brandData,setBrandData]= useState(brandInitialData);
    const [paginationModel,setPaginationModel] = useState({
        page: 0,
        pageSize: 25,
        filters: {
            searchKey: "",
            sortBy:'createdAt',
            sortType:'desc',
            filterOptions: []
        }
    })
    const [brandList, setBrandList] = useState([]);
    const [totalRowCount,setTotalRowCount] = useState(0);
    const [loadingList,setLoadingList] = useState(false)

    const fetchBrandList = async () => {
        try {
          setLoadingList(true)
          const listResponse = await BrandServices.allBrands({
            page: paginationModel.page,
            limit: paginationModel.pageSize,
            filters: {
              searchKey: paginationModel.filters.searchKey,   // Use the title filter from the paginationModel
              sortBy: paginationModel.filters.sortBy,
              sortType: paginationModel.filters.sortType,
              filterOptions: paginationModel.filters.filterOptions || []
            }
          });
          // console.log("Service list Response:",listResponse)
          // setValue('status', paginationModel.filters.status)
          if (listResponse.success == '1') {
            setBrandList(listResponse.data.list);
            setTotalRowCount(listResponse.data.totalItems);
          }
          else {
            //   Swal.fire('Request failed','','error')
          }
        } catch (error) {
          Swal.fire(error.message, '', 'error')
        }
        setLoadingList(false)
    };

    const [selectedBrandData, setSelectedBrandData] = useState(null);

    return (
        <BrandContext.Provider value={{ brandInitialData,brandData,setBrandData,fetchBrandList,brandList,paginationModel,setPaginationModel,totalRowCount,loadingList,selectedBrandData, setSelectedBrandData}}>
            <PageHeaderLayout headerTitle={'Manage Brands'}>
                {/* <Button size='small' variant='contained' onClick={() => modalOpen({})} endIcon={<AddCircleIcon sx={{fontSize:'.85rem'}}/>} sx={{ textTransform:'capitalize' }}>
                    Add
                </Button> */}
                <Button size='small' variant='contained' onClick={() => navigate(-1)} endIcon={<ArrowBack sx={{fontSize:'.85rem'}}/>} sx={{ textTransform:'capitalize' }}>
                    Back
                </Button>
            </PageHeaderLayout>
        
            <Grid container spacing={1}>            
                <Grid item xs={12} lg={5}>
                    <AddEditBrand/>
                </Grid>
                <PermissionGuard feature="brand" permission="canView">
                    <Grid item xs={12} lg={7}>
                        <BrandList/>
                    </Grid>
                </PermissionGuard>
            </Grid>
        </BrandContext.Provider>
    )
}

export { BrandContext }